<ng-template>
  <div (click)="closed.emit()" class="dropdown" [ngClass]="classes" [@inOutAnimation]>
    <ng-content></ng-content>
  </div>
</ng-template>
